module.exports = (fox, $) => {
    'use strict';
    
    require('fox-dynamic-injection!fox-template-loader!../../templates/sitepage/404')(fox);

	fox.registerWidget('SitePage_404', {
        
        configure() {
            this.registerOptions('', {
                template: 'sitepage_404'
            });

            this.callParent('configure', arguments);
        }

    });
};


// WEBPACK FOOTER //
// ./widget/sitepage/404.es.js